
import React, { Component } from "react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ResponsiveX } from "IZOX/STATIC";
import { ActivityIndicator, HStack, Spacer, VStack, XButton, XImage, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import Breadcrumb from "shared/Breadcrumb";
import { SysConfig } from "__SYSDefault/Config";
import { observer } from "mobx-react";
import HContactInfo from "shared/HContactInfo";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import HContactInfoM from "shared/HContactInfoM";
import FooterM from "shared/FooterM";

/**
 * @augments {Component<Props, State>}
 */
class PPayment extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetInfo();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PPayment.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _GetInfo = async () => {
    let info = await APIExpress.WebSettings.GetInfo();
    this.setState({
      info: info
    });
  }

  _Copy = (text) => {
    navigator.clipboard.writeText(text);
    GFunc.Alert("Copied to Clipboard");
  }

  renderBreadcrumb(){
    return (
      <HStack HAlign="[">
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "Payment",
            TC: "支付"
          }}/>
      </HStack>
    );
  }

  renderBankCard(component, number){
    return (
      <VStack bColor={ColorX.CSS("Grass")} bW={1} HAlign="[" width={266}>
        <HStack height={64} p={8} HAlign="[">
          {component}
        </HStack>
        <HStack bgColor={ColorX.CSS("Grass")} p={8}>
          <VStack p={8} fullWidth HAlign="[" >
            <XText color={ColorX.CSS("pureWhite")} fontSize={12}>
              {LocaleX.Parse({
                EN: "Account No.",
                TC: "戶口號碼"
              })}
            </XText>
            <XText color={ColorX.CSS("pureWhite")} fontSize={16} bold>
              {number}
            </XText>
          </VStack>
          <Spacer/>
          <XButton onPress={() => this._Copy(number)}
            color={ColorX.CSS("Axit")} 
            bgColor={ColorX.CSS("pureWhite")} round={50}
            padding={0}
            pH={16}>
            <HStack width={"auto"}>
              <XText fontSize={14} width={50} textAlign="|">
                {LocaleX.Parse({
                  EN: "Copy",
                  TC: "複製"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </VStack>
    );
  }

  renderMethods(){
    let {info} = this.state;
    let {payment} = info ?? {};
    return (
      <VStack fullWidth HAlign="[">
        <XText>
          {LocaleX.Parse({
            EN: "Mutual Insurance Consultants Co. Bank A/C No.",
            TC: "衡安保險顧問公司 銀行戶口號碼"
          })}
        </XText>
        <HStack spacing={24} HAlign="[">
          {this.renderBankCard(
            <XImage width={134} source={"Images/home/hangseng.png"}/>,
            payment?.hangseng)}
          {/* {this.renderBankCard(
            <XImage width={134} source={"Images/home/bank.png"}/>,
            payment?.winglung)} */}
          {this.renderBankCard(
            <XText bold fontSize={22}>{"FPS"}</XText>,
            payment?.FPS)}
        </HStack>
      </VStack>
    );
  }

  renderMain(){
    let {info} = this.state;
    return (
      <VStack spacing={16} width={848} HAlign="[">
        <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
          {LocaleX.Parse({
            EN: "Payment Method",
            TC: "付款方法"
          })}
        </XText>
        {this.renderMethods()}
        <HStack bColor={ColorX.CSS("Blood")} bW={1} p={12} spacing={8} HAlign="[">
          {IconX.Get("feather", "info", 20, ColorX.CSS("Blood"))}
          <XText fontSize={12} color={ColorX.CSS("Blood")} bold style={{whiteSpace: "pre-line"}}>
            {LocaleX.Parse({
              EN: "After the transfer, please keep the deposit receipt and fax the receipt to our company.\nAnd write relevant information on the fax copy.",
              TC: "轉帳後，請保留存款收據並將收據傳真至本公司。\n並在傳真件上寫上相關資訊。"
            })}
          </XText>
        </HStack>
        <HContactInfo info={info}/>
      </VStack>
    );
  }

  renderNormal(){
    return (
      <VStack fullWidth>
        <VStack width={SysConfig.ContentWidth} pH={80}>
          {this.renderBreadcrumb()}
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

  renderBreadcrumbM(){
    return (
      <HStack HAlign="[" pH={26}>
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "Payment",
            TC: "支付"
          }}/>
      </HStack>
    );
  }

  renderBankCardM(component, number){
    return (
      <VStack bColor={ColorX.CSS("Grass")} bW={1} HAlign="[" fullWidth>
        <HStack height={64} p={8} HAlign="[">
          {component}
        </HStack>
        <HStack bgColor={ColorX.CSS("Grass")} p={8}>
          <VStack p={8} fullWidth HAlign="[" >
            <XText color={ColorX.CSS("pureWhite")} fontSize={12}>
              {LocaleX.Parse({
                EN: "Account No.",
                TC: "戶口號碼"
              })}
            </XText>
            <XText color={ColorX.CSS("pureWhite")} fontSize={16} bold>
              {number}
            </XText>
          </VStack>
          <Spacer/>
          <XButton onPress={() => this._Copy(number)}
            color={ColorX.CSS("Axit")} 
            bgColor={ColorX.CSS("pureWhite")} round={50}
            padding={0}
            pH={16}>
            <HStack width={"auto"}>
              <XText fontSize={14} width={50} textAlign="|" bold>
                {LocaleX.Parse({
                  EN: "Copy",
                  TC: "複製"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </VStack>
    );
  }

  renderMethodsM(){
    let {info} = this.state;
    let {payment} = info ?? {};
    return (
      <VStack fullWidth spacing={26}>
        <XText>
          {LocaleX.Parse({
            EN: "Mutual Insurance Consultants Co. Bank A/C No.",
            TC: "衡安保險顧問公司 銀行戶口號碼"
          })}
        </XText>
        <VStack fullWidth spacing={24} HAlign="[">
          {this.renderBankCardM(
            <XImage width={134} source={"Images/home/hangseng.png"}/>,
            payment?.hangseng)}
          {this.renderBankCardM(
            <XImage width={134} source={"Images/home/bank.png"}/>,
            payment?.winglung)}
          {this.renderBankCardM(
            <XText bold fontSize={22}>{"FPS"}</XText>,
            payment?.FPS)}
        </VStack>
      </VStack>
    );
  }

  renderMainM(){
    return (
      <VStack spacing={16} fullWidth pH={82}>
        <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
          {LocaleX.Parse({
            EN: "Payment Method",
            TC: "付款方法"
          })}
        </XText>
        {this.renderMethodsM()}
        <HStack bColor={ColorX.CSS("Blood")} bW={1} p={12} spacing={8} HAlign="[">
          {IconX.Get("feather", "info", 20, ColorX.CSS("Blood"))}
          <XText fontSize={12} color={ColorX.CSS("Blood")} bold style={{whiteSpace: "pre-line"}}>
            {LocaleX.Parse({
              EN: "After the transfer, please keep the deposit receipt and fax the receipt to our company.\nAnd write relevant information on the fax copy.",
              TC: "轉帳後，請保留存款收據並將收據傳真至本公司。\n並在傳真件上寫上相關資訊。"
            })}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderMobile(){
    let {info} = this.state;
    return (
      <VStack fullWidth>
        {this.renderBreadcrumbM()}
        {this.renderMainM()}
        <HStack pH={26}>
          <HContactInfoM info={info}/>
        </HStack>
        <FooterM/>
      </VStack>
    );
  }

  render(){
    let {info} = this.state;
    if(!info){
      return (
        <VStack fullWidth fullHeight VAlign="-" HAlign="|">
          <ActivityIndicator loading size={Math.min(100, window.innerWidth * 0.5)} thickness={10}/>
        </VStack>
      );
    }
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(PPayment);
